import { memo, useReducer, useCallback } from "react";
import { useCreateLeadMutation } from "@/app/leads/leads.api";
import { Branch } from "@/app/branchs/branch.types";
import NavbarFilterDirectCenter from "@/shared/components/organisms/NavbarFilterDirectCenter";
import TableListCatchment from "./TableListCatchment";
import LoadTable from "@/shared/components/organisms/LoadTable";
import { CreateLeadModal } from "./CreateLeadModal";
import { toasts } from "@/shared/utils/toasts";
import { useCatchmentFilters } from "../hooks/useCatchmentFilters";
import { catchmentReducer, initialState } from "../reducers/catchmentReducer";
import NavbarFilterCatchment from "./NavbarFilterCatchment";

interface CatchmentDirectCenterPageProps {
  isLoading: boolean;
  isError: boolean;
  people: any[];
  branches: Branch[];
  tagsMarketing: Array<{ id: string; name: string }>;
  campaigns: Array<{ id: string; name: string }>;
  exportData: () => void;
  branchId: string;
  createUser: (user: any) => void;
  formValues: any;
  dispatch: any;
  selectedBranch: any;
  selectBranch: any;
  isKpisOpen: boolean;
  isDrawerOpen: boolean;
  isCreateModalOpen;
  refetchPeople: any;
}

export const CatchmentDirectCenterPage = memo<CatchmentDirectCenterPageProps>(
  ({
    isLoading,
    isError,
    people,
    branches,
    tagsMarketing,
    campaigns,
    exportData,
    branchId,
    createUser,
    dispatch,
    formValues,
    selectBranch,
    selectedBranch,
    isCreateModalOpen,
    refetchPeople,
  }) => {
    const [createLead, { isLoading: isLoadingCreate }] =
      useCreateLeadMutation();

    const handleFilterChange = useCallback((field: string, value: any) => {
      dispatch({ type: "SET_FILTER", field, value });
    }, []);

    const toggleCreateModal = useCallback(() => {
      dispatch({ type: "TOGGLE_CREATE_MODAL" });
    }, []);

    const toggleDrawer = useCallback(() => {
      dispatch({ type: "TOGGLE_DRAWER" });
    }, []);

    const toggleKpis = useCallback(() => {
      dispatch({ type: "TOGGLE_KPIS" });
    }, []);

    console.log("selectedBranch", selectedBranch);

    const handleCreateLead = async (formData: any) => {
      if (!selectedBranch) {
        toasts.error("Error", "Por favor, selecciona una sucursal válida.");
        return;
      }

      try {
        await createLead({
          ...formData,
          branch_id: selectedBranch.id,
        }).unwrap();

        toggleCreateModal();
        toasts.success(
          "Creación exitosa",
          "El lead ha sido creado correctamente"
        );
        refetchPeople();
      } catch (error) {
        console.error("Error creating lead:", error);
        toasts.error("Error", "No se pudo crear el lead.");
      }
    };

    if (isLoading) {
      return <LoadTable />;
    }

    return (
      <div>
        <NavbarFilterDirectCenter
          selectBranch={selectBranch}
          selectedBranch={selectedBranch}
          branches={branches}
          branchId={branchId}
          optionsTagsMarketing={tagsMarketing}
          campaigns={campaigns}
          exportData={exportData}
          setOpenCreateLeaModal={toggleCreateModal}
          filterValues={formValues}
          onFilterChange={handleFilterChange}
        />

        {isError && <p>Error fetching data</p>}

        {!isLoading && !isError && (
          <TableListCatchment
            people={people}
            createUser={createUser}
            branchId={branchId}
          />
        )}

        <CreateLeadModal
          isOpen={isCreateModalOpen}
          onClose={toggleCreateModal}
          onSubmit={handleCreateLead}
          isLoading={isLoadingCreate}
        />
      </div>
    );
  }
);
